import {createSelector, MemoizedSelector} from '@ngrx/store';
import {getInvoicesState, StateWithInvoices} from '../../../store/selectors/custom-invoice.selector';
import {B2BDocumentTypeList, DocumentTypeList} from '../../../invoices.model';
import {LoaderState} from '../../../../../../core/state/utils/loader/loader-state';
import {StateUtils} from '@spartacus/core';

export const INVOICES_DOCUMENT_TYPE_SELECTOR = 'documentType';

export const getInvoicesDocumentTypeState: MemoizedSelector<StateWithInvoices, LoaderState<B2BDocumentTypeList>> =
  createSelector(getInvoicesState, (state) => state[INVOICES_DOCUMENT_TYPE_SELECTOR]);

export const getInvoicesDocumentTypeValue: MemoizedSelector<StateWithInvoices, B2BDocumentTypeList> =
  createSelector(getInvoicesDocumentTypeState, (state) => StateUtils.loaderValueSelector(state));

export const getInvoicesDocumentTypeLoaderState: MemoizedSelector<StateWithInvoices, boolean> =
  createSelector(getInvoicesDocumentTypeState, (state) => StateUtils.loaderLoadingSelector(state));

export const getInvoicesDocumentTypeSuccessState: MemoizedSelector<StateWithInvoices, boolean> =
  createSelector(getInvoicesDocumentTypeState, (state) => StateUtils.loaderSuccessSelector(state));

export const getInvoicesDocumentTypeErrorState: MemoizedSelector<StateWithInvoices, boolean> =
  createSelector(getInvoicesDocumentTypeState, (state) => StateUtils.loaderErrorSelector(state));
